import { createValidations, Validation, ValidationHandler } from './validator';

export type MatchValidation<T> = (regex: RegExp, message: string, id?: string) => Validation<T>;

export const createMatch =
  <T>(chain: ValidationHandler<T>[]) =>
  (regex: RegExp, message: string, id?: string) =>
    createValidations<T>([
      ...chain,
      async (value) => {
        if (typeof value === 'string') {
          return [{ valid: regex.test(value as string), message, id }];
        }
        return [{ valid: false, message, id }];
      }
    ]);
